import React from 'react';
import proptypes from 'prop-types';
const { node, shape, bool } = proptypes;
import { HelmetContext } from './HelmetContext';

const HelmetProvider = ({ children, context, canUseDom = true }) => {

  const value = {
    context,
    canUseDom,
  };
  return (
    <HelmetContext.Provider value={value}>
      {children}
    </HelmetContext.Provider>
  );
};

HelmetProvider.propTypes = {
  children: node.isRequired,
  context: shape({}).isRequired,
  canUseDom: bool
};

export { HelmetProvider };
